import { Controller } from '@hotwired/stimulus';
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export default class extends Controller {
  static targets = ['swiper', 'pagination'];

  connect() {
    const swiperOptions = {
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      pagination: {
        el: this.paginationTarget,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    this.swiper = new Swiper(this.swiperTarget, swiperOptions);
  }

  thumbClick(e) {
    this.swiper.slideTo(parseInt(e.currentTarget.dataset.thumb, 10) + 1);
  }
}
